import Link from 'next/link'
import styled, { css } from 'styled-components'
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'

import { theme } from '@/styles/theme'
import { PxToVw } from '@/utils/convertPx'

import { PickUpItem, PickUpItemProps } from './PickUpItem'
import { Button } from '@/components/elements/Button'
// import { NewsItem } from '@/components/elements/News/NewsItem'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { SectionTitleBackground } from '@/components/elements/SectionTitleBackground'
import { Spacer } from '@/components/elements/Spacer'
import { Layout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { RecentNewsList } from '@/components/enpages/Ir/RecentNewsList'
import { DHeading } from '@/components/layouts/Ir/Heading'

import type { NewsRelease } from '@/types/newsRelease'

SwiperCore.use([Pagination, Navigation, Autoplay])

type HomePageProps = {
  newsRelease: NewsRelease[]
}

export const HomePage = ({ newsRelease }: HomePageProps) => {
  const images = [
    '/images/home-slide-1.webp',
    '/images/home-slide-2.webp',
    '/images/home-slide-3.webp',
    '/images/home-slide-4.webp',
    '/images/home-slide-5.webp',
  ]

  const pickupList: PickUpItemProps[] = [
    {
      link: 'en/company/topmessage/',
      imgPath: '/images/home-top-message.svg',
      imgWidth: 133,
      imgHeight: 174,
      title: 'Top Message',
      alignItems: 'flex-end',
      cssProp: css`
        img {
          max-width: 100%;
          transform: translateX(23%);
        }
      `,
    },
    {
      link: 'en/company/philosophy/',
      imgPath: '/images/home-philosophy.svg',
      imgWidth: 100,
      imgHeight: 195,
      title: 'Philosophy',
      alignItems: 'center',
      cssProp: css`
        img {
          max-height: 120px;
        }
      `,
    },
    // {
    //   link: 'en/news/blog/',
    //   imgPath: '/images/home-pr-blog.svg',
    //   imgWidth: 186,
    //   imgHeight: 147,
    //   title: 'Public relations blog',
    //   alignItems: 'center',
    //   cssProp: css`
    //     img {
    //       max-width: 112px;
    //       transform: translateY(6%);
    //     }
    //   `,
    // },
  ]

  return (
    <Layout>
      <>
        <Head
          title="TRIAL Holdings, Inc. | Enrich every aspect of people&apos;s lives through Retail DX."
          hasTitleSuffix={false}
          description="TRIAL Holdings envisions &apos;Enrich every aspect of people&apos;s lives through all we do.&apos; We are a company that promotes the transformation of global real commerce through technology and human experiential knowledge."
          ogp={{ url: '' }}
        />
        <Wrapper>
          <TopSlider>
            <SlideWrapper>
              <p>
                Enrich every aspect of people&apos;s lives
                through all we do.
              </p>
              <Swiper
                style={{ zIndex: 1 }}
                slidesPerView={1}
                pagination={{
                  clickable: true,
                  bulletClass: `swiper-pagination-bullet custom-bullet`,
                  bulletActiveClass: `swiper-pagination-bullet-active custom-bullet-active`,
                }}
                loop={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                speed={2000}
              >
                {images.map((src: string, index: number) => {
                  return (
                    <SwiperSlide key={`${index}`}>
                      <SlideImage src={src} alt="" />
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </SlideWrapper>
          </TopSlider>
          {/* <NewsRoom>
            <SectionTitle
              titleText="News"
              subTitleText=""
              color="normal"
              as="h2"
            />
            {/* <NewsList>
              {newsRelease.map(({ _id, tag, title, publishDate }, index) => (
                <NewsItem
                  key={_id}
                  publishDate={publishDate}
                  tag={tag}
                  title={title}
                  link={`/news/release/${_id}`}
                  isNotShowBottom={index === 2}
                />
              ))}
            </NewsList> */}
          {/* 緊急で英語のニュースを追加 */}
          {/*
            <div style={{ marginTop: '20px' }}>
              <Spacer h={{ pc: 30, sp: 50 }} />
              <EnNewslist>
              <div>
                <p>2023/12/28</p>
                <Link href="/en/news/ennews">Establishment of The English Version of The Website</Link>
              </div>
              </EnNewslist>
              <div style={{ marginTop: '20px' }}></div>
            </div>
            <NewsMoreButton>
              <Link href="/en/news/" passHref>
                <a>
                  <Button btnStyle="transparent">More</Button>
                </a>
              </Link>
            </NewsMoreButton>
          </NewsRoom>
           */}
          <NewsRoom>
            <SubSectionTitle>
              <DHeading>News Release</DHeading>
              <Link href="/en/news/release/" passHref>
                <a>
                  <NewsMoreButton btnStyle="transparent">See More</NewsMoreButton>
                </a>
              </Link>
            </SubSectionTitle>
            <Spacer h={{ sp: 30, pc: 80 }} />
            <EnNewslist>
              <div>
                <time>2023/12/28</time>
                <p><Link href="/en/news/ennews">Establishment of The English Version of The Website</Link></p>
              </div>
            </EnNewslist>
            {/*
            <PRNewsList>
              {newsRelease.map(({ _id, tag, title, publishDate }, index) => (
                <NewsItem
                  key={_id}
                  publishDate={publishDate}
                  tag={tag}
                  title={title}
                  link={`/en/news/release/${_id}`}
                  isNotShowBottom={index === 2}
                />
              ))}
            </PRNewsList>
            */}
            <Spacer h={{ sp: 34, pc: 90 }} />
            <SubSectionTitle>
              <DHeading>IR News</DHeading>
              <Link href="/en/ir/news/" passHref>
                <a>
                  <NewsMoreButton btnStyle="transparent">See More</NewsMoreButton>
                </a>
              </Link>
            </SubSectionTitle>
            <Spacer h={{ sp: 30, pc: 80 }} />
            <IRNewsList>
              <RecentNewsList />
            </IRNewsList>
          </NewsRoom>
          <Spacer h={{ pc: 30, sp: 50 }} />
          <PickUp>
            <SectionTitleBackground
              padding={{
                pc: `${PxToVw(210, 1440)} 0 ${PxToVw(130, 1440)}`,
                sp: `87px 0 80px`,
              }}
              bgColor="trial-blue"
              outerBgColor="white"
            >
              <SectionTitle
                color="white"
                titleText="Pick Up"
                subTitleText=""
                as="h2"
              />
              <PickUpList>
                {pickupList.map(
                  ({
                    link,
                    imgPath,
                    title,
                    imgWidth,
                    imgHeight,
                    alignItems,
                    cssProp,
                  }) => (
                    <PickUpItem
                      key={title}
                      link={link}
                      imgPath={imgPath}
                      title={title}
                      imgWidth={imgWidth}
                      imgHeight={imgHeight}
                      alignItems={alignItems}
                      cssProp={cssProp}
                    />
                  )
                )}
              </PickUpList>
            </SectionTitleBackground>
          </PickUp>
        </Wrapper>
      </>
    </Layout>
  )
}

const Wrapper = styled.div`
  overflow: hidden;
`

const SlideImage = styled.img`
  width: 100vw;
  height: ${PxToVw(643, 1440)};
`

const TopSlider = styled.section`
  .swiper-pagination {
    bottom: 27px;
  }

  .swiper-pagination-bullet.custom-bullet {
    background-color: #fff;
    margin: 0 18px !important;
    width: 14px;
    height: 14px;
    opacity: 1;
  }

  .swiper-pagination-bullet-active.custom-bullet-active {
    background-color: ${theme.colors.trialBlue};
  }

  @media screen and (max-width: 1047px) {
    .swiper-pagination {
      position: relative !important;
      bottom: 5px;
      margin-top: 13px;
    }

    .swiper-pagination-bullet.custom-bullet {
      width: 11px;
      height: 11px;
      background-color: ${theme.colors.backgroundBlue};
    }

    .swiper-pagination-bullet-active.custom-bullet-active {
      background-color: ${theme.colors.trialBlue};
    }
  }
`

const NewsRoom = styled.section`
  width: 1040px;
  margin: 90px auto 0;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px auto 0;
  }
`

// const NewsList = styled.div`
//   margin-top: 70px;
//   display: flex;
//   flex-direction: column;
//   gap: 24px;

//   @media screen and (max-width: 1047px) {
//     margin-top: 34px;
//     padding: 0 20px;
//   }
// `

// const NewsMoreButton = styled.div`
//   margin-top: 60px;
//   display: flex;
//   justify-content: center;

//   @media screen and (max-width: 1047px) {
//     margin-top: 40px;
//   }
// `

const NewsMoreButton = styled(Button)`
  padding: 11px 26px 13px 26px;
  width: 135px;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  @media screen and (max-width: 1047px) {
    padding: 2px 18px 4px 18px;
    font-size: 13px;
    width: 104px;
    height: 32px;
  }
`

const PickUp = styled.section`
  // TODO IRを追加するときは削除する
  > div::after {
    display: none;
  }
`

const PickUpList = styled.ul`
  margin: 70px auto 0;
  display: flex;
  justify-content: space-around;
  column-gap: 30px;
  width: 1040px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 34px auto 0;
    flex-direction: column;
    align-items: center;
    row-gap: 30px;
    padding: 0 20px;
  }
`

const SlideWrapper = styled.div`
  position: relative;

  p {
    // position: absolute;
    z-index: 2;
    top: ${PxToVw(110, 1440)};
    color: #fff;
    font-size: ${PxToVw(30, 1440)};
    font-weight: bold;
    letter-spacing: 3.2px;
    line-height: 46px;
    background-color: rgba(0, 45, 101, 0.9);
    padding-top: ${PxToVw(20, 1440)};
    padding-left: ${PxToVw(100, 1440)};
    padding-bottom: ${PxToVw(20, 1440)};
    padding-right: 20px;
    // text-align: center;

    br {
      display: none;
    }
  }

  @media screen and (max-width: 1000px) {
    p {
      font-size: ${PxToVw(14, 390)};
      letter-spacing: 1.4px;
      line-height: 26px;
      line-height: ${PxToVw(20, 390)};

      padding-top: ${PxToVw(5, 390)};
      padding-bottom: ${PxToVw(5, 390)};
      padding-right: ${PxToVw(24, 390)};
      padding-left: ${PxToVw(34, 390)};

      br {
        display: block;
      }
    }
  }
`


const SubSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  @media screen and (max-width: 1047px) {
    gap: 10px;
    padding: 0 20px;
  }
`

// const PRNewsList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
//   &[aria-hidden='true'] {
//     display: none;
//   }
//   @media screen and (max-width: 1047px) {
//     padding: 0 20px;
//   }
// `

const IRNewsList = styled.div`
  &[aria-hidden='true'] {
    display: none;
  }
  @media screen and (max-width: 1047px) {
    padding: 0 20px;
  }
`

const EnNewslist = styled.div`
div {
  display: flex;
  align-items: center;
}

p {
  margin-right: 40px;
  margin-left: 50px
}

time {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: 0;
  color: ${theme.colors.textTitle};
}

a:hover {
  text-decoration: underline;
}
`
